module.exports = __webpack_public_path__ + "img/10005.99b65f05.jpg";